import React, { useState, useEffect, useCallback, createContext, useContext } from 'react';
import axios from 'axios';

const API = `${window.location.origin}/api`;

const TeamContext = createContext(null);

export function useTeam() {
  return useContext(TeamContext);
}

export function TeamProvider({ children }) {
  const [teams, setTeams] = useState([]);
  const [activeTeam, setActiveTeam] = useState(null); // null = personal workspace
  const [loading, setLoading] = useState(true);

  const fetchTeams = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/teams`, { withCredentials: true });
      setTeams(res.data);
      // Restore last context
      const savedId = localStorage.getItem('helmcore_active_team');
      if (savedId) {
        const found = res.data.find(t => t.team_id === savedId);
        if (found) setActiveTeam(found);
      }
    } catch (err) {
      console.error('Failed to fetch teams:', err);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchTeams(); }, [fetchTeams]);

  const switchTeam = (team) => {
    setActiveTeam(team);
    if (team) {
      localStorage.setItem('helmcore_active_team', team.team_id);
    } else {
      localStorage.removeItem('helmcore_active_team');
    }
  };

  return (
    <TeamContext.Provider value={{ teams, activeTeam, switchTeam, fetchTeams, loading, isTeamMode: !!activeTeam }}>
      {children}
    </TeamContext.Provider>
  );
}
